// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"ea388441","769":"5b8dc788"}[chunkId] + ".chunk.js";
};